import { createSlice } from '@reduxjs/toolkit'

const commonSlice = createSlice({
    name: 'commonSlice',
    initialState: {
        backdropOpen: false,         
        page : 0,
        pageSize : 10,
        allListForExport : [],   
        isDailyReportExport : false,   

        codecToken : "",   
        authorization: "",
        appId: "",
        sessionId: "",
        userName: "",
        groupId: "",
        rightFormat: "",
        rights: "",  
        groupEuId: "",
        verifiedEntityLevel: "",      
    },
    reducers: {
        setBackdropOpen: (state, action) => {
            state.backdropOpen = action.payload;
        },       
        setPage: (state, action) => {
            state.page = action.payload;
        },  
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },       
        setAllListForExport: (state, action) => {
            state.allListForExport = action.payload;
        },        
        setIsDailyReportExport: (state, action) => {
            state.isDailyReportExport = action.payload;
        },     
        setCodecToken : (state, action) => {
            state.codecToken = action.payload;
        }, 
        setAuthorization: (state, action) => {
            state.authorization = action.payload;
        }, 
        setAppId: (state, action) => {
            state.appId = action.payload;
        }, 
        setSessionId: (state, action) => {
            state.sessionId = action.payload;
        }, 
        setUserName: (state, action) => {
            state.userName = action.payload;
        }, 
        setGroupId: (state, action) => {
            state.groupId = action.payload;
        }, 
        setRightFormat: (state, action) => {
            state.rightFormat = action.payload;
        }, 
        setRights: (state, action) => {
            state.rights = action.payload;
        }, 
        setGroupEuId: (state, action) => {
            state.groupEuId = action.payload;
        },  
        setVerifiedEntityLevel: (state, action) => {
            state.verifiedEntityLevel = action.payload;
        },  
                      
    }
})

export const { setBackdropOpen, setPage, setPageSize,  
     setAllListForExport, setIsDailyReportExport, setCodecToken,
        setAuthorization,
        setAppId,
        setSessionId,
        setUserName,
        setGroupId,
        setRightFormat,
        setRights,  
        setGroupEuId,
        setVerifiedEntityLevel } = commonSlice.actions

export default commonSlice.reducer